import { createFileRoute } from '@tanstack/react-router';
import { OutboxRouteView } from '@/pages/workspaces/outbox/outbox-route-view';

function OutboxRoute() {
  const { workspaceId, _splat } = Route.useParams();
  return <OutboxRouteView mount="outbox" workspaceId={workspaceId} splat={_splat ?? ''} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/outbox/$')({
  component: OutboxRoute,
});
